<template>
    <v-app id="inspire" :style="{ backgroundColor }" v-cloak class="app">
        <!-- S: PC 해더 -->
        <v-app-bar v-if="!$vuetify.breakpoint.mobile" app height="120" extension-height="60" absolute elevation="0" color="white" class="header pa-0 ma-0" v-intersect="{ handler: onScroll, options: { threshold: [0, 1.0] } }">
            <!-- E: PC 로고 -->
            <v-responsive width="100%" max-width="1200" height="120" class="mx-auto logo-wrap">
                <v-layout class="fill-height" align-center justify-center>
                    <router-link to="/">
                        <img :src="$store.state.ui.logo.pc" alt="DAEHAN BOOKSTORE" />
                    </router-link>
                </v-layout>
                <div v-show="scope.includes('cert')" class="header-timer"><v-icon class="mr-2">mdi-alarm</v-icon>{{ remain() }}</div>
            </v-responsive>
            <!-- E: PC 로고 -->

            <!-- S: PC 네비게이션 -->
            <v-responsive slot="extension" width="100%" class="ma-0 overflow-visible">
                <v-divider class="mb-n1px" />
                <v-layout justify-center align-center>
                    <v-responsive width="100%" :max-width="maxWidth" class="overflow-visible">
                        <global-navigation-bar>
                            <!-- S: PC 전체메뉴 (primary) -->
                            <v-menu slot="prepend" tile open-on-hover offset-y :close-on-content-click="false">
                                <v-btn slot="activator" slot-scope="{ on }" v-on="on" width="120" height="60" x-large tile color="primary darken-4">
                                    <v-icon size="28" class="mr-2 mt-1">mdi-menu</v-icon>
                                    <span class="font-size-18">전체</span>
                                </v-btn>
                                <v-list class="prepend-menu">
                                    <div class="prepend-menu__li">
                                        <div class="prepend-menu__tit">도서</div>
                                        <ul class="sub-menu">
                                            <li><router-link to="/shop/bestseller">베스트셀러</router-link></li>
                                            <li><router-link to="/shop/children">유아동</router-link></li>
                                            <li><router-link to="/shop/independent">독립출판물</router-link></li>
                                            <li><router-link to="/shop/discount">할인도서</router-link></li>
                                            <li><router-link to="/shop/exchange">모바일 도서교환권</router-link></li>
                                            <li><router-link to="/shop/ebook">eBook</router-link></li>
                                        </ul>
                                    </div>
                                    <div class="prepend-menu__li">
                                        <div class="prepend-menu__tit">나누리 상품권</div>
                                        <ul class="sub-menu">
                                            <li><router-link to="/purchase">상품권 구매</router-link></li>
                                            <li><router-link to="/mypage/cashes/charge">상품권 충전</router-link></li>
                                            <li><router-link to="/exchange">상품권 교환소</router-link></li>
                                        </ul>
                                    </div>
                                    <div class="prepend-menu__li">
                                        <div class="prepend-menu__tit">쿠폰</div>
                                        <ul class="sub-menu">
                                            <li><router-link to="/gshop/brand?_category&page=1">쿠폰교환소</router-link></li>
                                            <li><router-link to="/dshop/products">배송상품</router-link></li>
                                        </ul>
                                    </div>
                                    <div class="prepend-menu__li">
                                        <router-link :to="{ path: '/shop/products', query: { _category: shoppingCategory?._id, page: 1 } }" class="prepend-menu__tit">쇼핑</router-link>
                                    </div>
                                    <div class="prepend-menu__li">
                                        <router-link to="/offerwall" class="prepend-menu__tit">캐시 리워드</router-link>
                                    </div>
                                    <div class="prepend-menu__li">
                                        <div class="prepend-menu__tit">고객센터</div>
                                        <ul class="sub-menu">
                                            <li><router-link to="/center/notifications">공지사항</router-link></li>
                                            <li><router-link to="/center/faqs">자주 묻는 질문</router-link></li>
                                            <li><router-link to="/center/questions">1:1 문의</router-link></li>
                                        </ul>
                                    </div>
                                </v-list>
                            </v-menu>
                            <!-- E: PC 전체메뉴 (primary) -->

                            <!-- S: PC 서브 메뉴들 -->
                            <v-layout slot="center" class="px-20px">
                                <v-menu slot="prepend" tile open-on-hover offset-y>
                                    <v-btn :to="`/shop/bestseller?_category=${bestsellerCategory?._id}`" slot="activator" slot-scope="{ on }" v-on="on" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-20px">도서</v-btn>
                                    <div style="width: 390px; height: 600px">
                                        <v-list class="prepend-menu-sub">
                                            <div class="prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap">
                                                <router-link :to="`/shop/bestseller?_category=${bestsellerCategory?._id}`">베스트셀러</router-link>
                                                <ul class="prepend-menu-sub__li__dept3">
                                                    <li>
                                                        <router-link :to="`/shop/bestseller?_category=${bestsellerCategory?._id}`">전체</router-link>
                                                    </li>
                                                    <li v-for="category in bestsellerCategory?.children" :key="category._id">
                                                        <router-link :to="`/shop/bestseller?_category=${category._id}`">{{ category.name }}</router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap">
                                                <router-link :to="`/shop/children?_category=${childrenCategory?._id}`">유아동</router-link>
                                                <ul class="prepend-menu-sub__li__dept3">
                                                    <li>
                                                        <router-link :to="`/shop/children?_category=${childrenCategory?._id}`">전체</router-link>
                                                    </li>
                                                    <li v-for="category in childrenCategory?.children" :key="category._id">
                                                        <router-link :to="`/shop/children?_category=${category._id}`">{{ category.name }}</router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prepend-menu-sub__li">
                                                <router-link to="/shop/independent">독립출판물</router-link>
                                            </div>
                                            <div class="prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap">
                                                <router-link :to="`/shop/discount?_category=${discountCategory?._id}`">할인도서</router-link>
                                                <ul class="prepend-menu-sub__li__dept3">
                                                    <li>
                                                        <router-link :to="`/shop/discount?_category=${discountCategory?._id}`">전체</router-link>
                                                    </li>
                                                    <li v-for="category in discountCategory?.children" :key="category._id">
                                                        <router-link :to="`/shop/discount?_category=${category._id}`">{{ category.name }}</router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prepend-menu-sub__li">
                                                <router-link to="/shop/exchange">모바일 도서교환권</router-link>
                                            </div>
                                            <div class="prepend-menu-sub__li">
                                                <router-link :to="`/shop/ebook`">eBook</router-link>
                                            </div>
                                        </v-list>
                                    </div>
                                </v-menu>
                                <v-menu slot="prepend" tile open-on-hover offset-y>
                                    <v-btn to="/exchange" slot="activator" slot-scope="{ on }" v-on="on" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-20px">나누리 상품권</v-btn>
                                    <v-list class="prepend-menu-sub">
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/purchase">상품권 구매</router-link>
                                        </div>
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/mypage/cashes/charge">상품권 충전</router-link>
                                        </div>
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/exchange">상품권 교환소</router-link>
                                        </div>
                                    </v-list>
                                </v-menu>
                                <v-menu slot="prepend" tile open-on-hover offset-y>
                                    <v-btn to="/gshop/brand?_category&page=1" slot="activator" slot-scope="{ on }" v-on="on" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-20px">쿠폰</v-btn>
                                    <v-list class="prepend-menu-sub">
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/gshop/brand?_category&page=1">쿠폰교환소</router-link>
                                        </div>
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/dshop/products">배송상품</router-link>
                                        </div>
                                    </v-list>
                                </v-menu>
                                <v-btn :to="{ path: '/shop/products', query: { _category: shoppingCategory?._id, page: 1 } }" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-20px">쇼핑</v-btn>
                                <v-btn to="/board/event" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-30px">이벤트</v-btn>
                                <v-btn to="/offerwall" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-30px new">캐시 리워드</v-btn>
                                <v-menu slot="prepend" tile open-on-hover offset-y>
                                    <v-btn to="/center/notifications" slot="activator" slot-scope="{ on }" v-on="on" :ripple="false" active-class="no-active" height="60" dark text tile x-large color="black" class="font-size-18 px-20px">고객센터</v-btn>
                                    <v-list class="prepend-menu-sub">
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/center/notifications">공지사항</router-link>
                                        </div>
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/center/faqs">자주묻는질문</router-link>
                                        </div>
                                        <div class="prepend-menu-sub__li">
                                            <router-link to="/center/questions">1:1 문의</router-link>
                                        </div>
                                    </v-list>
                                </v-menu>
                            </v-layout>
                            <!-- E: PC 서브 메뉴들 -->

                            <!-- S: PC 검색바 -->
                            <v-responsive slot="append" width="100%" height="60" class="px-4">
                                <v-row no-gutters align="center">
                                    <v-col>
                                        <v-text-field v-model="searchValue" name="searchValue" type="search" autocomplete="off" placeholder="도서, 상품 검색" hide-details height="60" @keydown.enter="search" />
                                    </v-col>
                                    <v-col v-show="searchValue" cols="auto">
                                        <v-icon size="28" @click="searchValue = null" class="mr-1">mdi-close</v-icon>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-icon size="28" @click="search">mdi-magnify</v-icon>
                                    </v-col>
                                </v-row>
                            </v-responsive>
                            <!-- E: PC 검색바 -->
                        </global-navigation-bar>
                    </v-responsive>
                </v-layout>
            </v-responsive>
            <!-- E: PC 네비게이션 -->
        </v-app-bar>
        <!-- E: PC 해더 -->

        <!-- S: Mobile 해더 -->
        <v-app-bar v-if="$vuetify.breakpoint.mobile" height="130" color="white" elevation="0" v-intersect="{ handler: onScroll, options: { threshold: [0, 1.0] } }">
            <v-layout wrap fill-height>
                <v-responsive width="100%" height="60">
                    <v-layout align-center fill-height>
                        <!-- Mobile 햄버거 -->
                        <v-app-bar-nav-icon @click="drawer = true" width="60" height="60" class="transparent" />

                        <v-spacer />

                        <!-- Mobile 로고 -->
                        <router-link to="/">
                            <div class="text-center" style="max-width: 190px; height: 48px">
                                <img :src="$store.state.ui.logo.mobile" alt="DAEHAN BOOKSTORE" />
                            </div>
                        </router-link>

                        <v-spacer />

                        <v-layout v-show="scope.includes('cert')" align-center class="font-size-14 ml-8px" style="width: 58px"> <v-icon size="20" class="mr-2px">mdi-alarm</v-icon>{{ remain() }} </v-layout>

                        <!-- 장바구니 아이콘 -->
                        <v-btn icon to="/mypage/shop/carts" width="60" height="60" active-class="no-active" class="transparent"><v-icon>mdi-cart</v-icon></v-btn>
                    </v-layout>
                </v-responsive>
                <v-responsive width="100%" height="70">
                    <v-container class="pt-8px">
                        <v-text-field v-model="searchValue" type="search" autocomplete="off" outlined hide-details clearable background-color="white" placeholder="도서, 상품 검색" append-icon="mdi-magnify" @keydown.enter="search" @click:append="search" class="v-input--large primary" />
                    </v-container>
                    <v-divider class="border-2 primary mt-12px" />
                </v-responsive>
            </v-layout>
        </v-app-bar>
        <!-- E: Mobile 해더 -->

        <!-- S: Mobile 네비게이션 -->
        <v-navigation-drawer v-model="drawer" app fixed temporary height="auto" width="100%" class="mobile-navigation-drawer grey lighten-4" touchless>
            <v-list class="pa-0">
                <!-- 로그인 / 로그아웃 -->
                <v-list-item class="primary" dark>
                    <v-list-item-action><v-icon>mdi-account-circle</v-icon></v-list-item-action>
                    <v-list-item-title>
                        <span v-if="logoff" @click="login">로그인</span>
                        <span v-if="logon" @click="logout">로그아웃</span>
                    </v-list-item-title>
                    <v-list-item-action @click="drawer = false"><v-icon>mdi-close</v-icon></v-list-item-action>
                </v-list-item>

                <!-- Mobile 서브메뉴 : 도서 -->
                <v-list-group class="white">
                    <v-list-item-title slot="activator"><b>도서</b></v-list-item-title>
                    <v-divider />
                    <v-list-item-group>
                        <v-list-item active-class="no-active" to="/shop/bestseller">
                            <v-list-item-title>베스트셀러</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/shop/children">
                            <v-list-item-title>유아동</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/shop/independent">
                            <!-- <v-list-item-title class="new--menu__li-mo">독립출판물</v-list-item-title> new class 요청들어오면 추가-->
                            <v-list-item-title>독립출판물</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/shop/discount">
                            <v-list-item-title>할인도서</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                    <v-list-item active-class="no-active" to="/shop/exchange">
                        <v-list-item-title>모바일 도서교환권</v-list-item-title>
                    </v-list-item>
                    <v-list-item active-class="no-active" to="/shop/ebook">
                        <v-list-item-title>eBook</v-list-item-title>
                    </v-list-item>
                </v-list-group>
                <v-divider />

                <!-- Mobile 서브메뉴 : 나누리 상품권 -->
                <v-list-group class="white">
                    <v-list-item-title slot="activator"><b>나누리 상품권</b></v-list-item-title>
                    <v-divider />
                    <v-list-item-group>
                        <v-list-item active-class="no-active" to="/purchase">
                            <v-list-item-title>상품권 구매</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/mypage/cashes/charge">
                            <v-list-item-title>상품권 충전</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/exchange">
                            <v-list-item-title>상품권 교환소</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list-group>
                <v-divider />

                <!-- Mobile 서브메뉴 : 쿠폰 -->
                <v-list-group class="white">
                    <v-list-item-title slot="activator"><b>쿠폰</b></v-list-item-title>
                    <v-divider />
                    <v-list-item-group>
                        <v-list-item active-class="no-active" to="/gshop/brand?_category&page=1">
                            <v-list-item-title>쿠폰교환소</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/dshop/products">
                            <v-list-item-title>배송상품</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list-group>
                <v-divider />

                <!-- Mobile 서브메뉴 : 쇼핑 -->
                <v-list-item class="white" active-class="no-active" :to="{ path: '/shop/products', query: { _category: shoppingCategory?._id, page: 1 } }">
                    <v-list-item-title><b>쇼핑</b></v-list-item-title>
                </v-list-item>

                <v-divider />

                <!-- Mobile 서브메뉴 : 이벤트 -->
                <!-- new 아이콘 -->
                <v-list-item class="white" active-class="no-active" to="/board/event">
                    <!-- <v-list-item-title class="new--menu-mo"><b>이벤트</b></v-list-item-title> -->
                    <v-list-item-title><b>이벤트</b></v-list-item-title>
                </v-list-item>

                <v-divider />

                <!-- Mobile 서브메뉴 : 캐시 리워드 -->
                <v-list-item class="white new" active-class="no-active" to="/offerwall">
                    <v-list-item-title><b>캐시 리워드</b></v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-list-group class="white">
                    <v-list-item-title slot="activator"><b>고객센터</b></v-list-item-title>
                    <v-divider />
                    <v-list-item-group>
                        <v-list-item active-class="no-active" to="/center/notifications">
                            <v-list-item-title>공지사항</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/center/faqs">
                            <v-list-item-title>자주묻는질문</v-list-item-title>
                        </v-list-item>
                        <v-list-item active-class="no-active" to="/center/questions">
                            <v-list-item-title>1:1 문의</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list-group>

                <v-divider />

                <v-layout class="mt-2 px-1">
                    <v-flex xs4 class="px-1">
                        <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage" active-class="no-active">
                            <div class="text-center">
                                <v-icon color="primary" size="32" class="d-block mx-auto">mdi-account-outline</v-icon>
                                <span>마이페이지</span>
                            </div>
                        </v-btn>
                    </v-flex>
                    <v-flex xs4 class="px-1">
                        <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/carts" active-class="no-active">
                            <div class="text-center">
                                <v-icon color="primary" size="32" class="d-block mx-auto">mdi-cart-outline</v-icon>
                                <span>장바구니</span>
                            </div>
                        </v-btn>
                    </v-flex>
                    <v-flex xs4 class="px-1">
                        <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/purchases" active-class="no-active">
                            <div class="text-center">
                                <v-icon color="primary" size="32" class="d-block mx-auto">mdi-text-box-outline</v-icon>
                                <span>주문배송조회</span>
                            </div>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <div class="font-size-14 font-weight-medium white grey--text text--darken-3 pa-16px mt-2">
                    <span class="font-weight-bold">대표전화</span>
                    <v-divider class="my-8px" />

                    <div class="mt-2px">
                        <span>Tel.</span>
                        <span class="font-size-22 font-weight-bold secondary--text ml-4px">1800-9510</span>
                    </div>
                    <div class="mt-2px">
                        <span>평일 10:00 - 17:00 / 점심 12:30 - 13:30</span>
                    </div>
                    <div class="mt-2px">
                        <span>주말 및 공휴일 휴무</span>
                    </div>
                </div>
            </v-list>
        </v-navigation-drawer>
        <!-- E: Mobile 네비게이션 -->

        <!-- S: PC Floating Actions Bar : Screen Right -->
        <client-floating-actions
            v-bind="{
                logoff,
                logon,
            }"
            v-on="{
                logout,
            }"
        />
        <!-- E: PC Floating Actions Bar : Screen Right -->

        <!-- S: gift-noti : Screen Bottom Left -->
        <client-gift-noti v-bind="{ logon }" />
        <!-- E: gift-noti : Screen Bottom Left -->

        <!-- S: Contents -->
        <v-main id="main">
            <div id="contents">
                <slot />
            </div>
        </v-main>
        <!-- E: Contents -->

        <!-- S: Footer -->
        <v-responsive min-height="200" v-intersect="{ handler: onFooter, options: { threshold: [0, 1.0] } }">
            <v-lazy v-model="showFooter" transition="fade-transition">
                <v-footer color="#51575b" class="px-0 py-10px py-md-18px">
                    <v-container>
                        <v-row no-gutters align="center">
                            <v-col cols="auto">
                                <v-row no-gutters align="center" justify="center" class="font-size-14">
                                    <v-col cols="auto">
                                        <div class="py-2px">
                                            <router-link to="/terms/tos" class="white--text">이용약관</router-link>
                                        </div>
                                    </v-col>
                                    <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height: 12px" /></v-col>
                                    <v-col cols="auto">
                                        <div class="py-2px">
                                            <router-link to="/terms/privacy" class="white--text">개인정보취급방침</router-link>
                                        </div>
                                    </v-col>
                                    <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height: 12px" /></v-col>
                                    <v-col cols="auto">
                                        <div class="py-2px">
                                            <router-link to="/terms/protection-policy" class="white--text">청소년 보호방침</router-link>
                                        </div>
                                    </v-col>
                                    <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height: 12px" /></v-col>
                                    <v-col cols="auto">
                                        <div class="py-2px">
                                            <router-link to="/terms/cash-policy" class="white--text">나누리캐시 약관</router-link>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-row align="center" class="row--small">
                                    <v-col v-show="!$vuetify.breakpoint.mobile" cols="auto">
                                        <a @click="open('https://instagram.com/daehan_bookstore?utm_medium=copy_link')"><v-img src="/images/icon-instagram.png" /></a>
                                    </v-col>
                                    <v-col v-show="!$vuetify.breakpoint.mobile" cols="auto">
                                        <a @click="open('https://blog.naver.com/dhbooks_')"><v-img src="/images/icon-nblog.png" /></a>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-footer>
            </v-lazy>

            <v-lazy v-model="showFooter" transition="fade-transition">
                <v-footer color="white" class="px-0 py-26px pt-md-34px pb-md-40px">
                    <v-container>
                        <v-row no-gutters align="center">
                            <v-col cols="12" lg="3">
                                <v-row no-gutters align="center" justify="space-between">
                                    <v-col>
                                        <v-img src="/images/logo2.png" :width="$vuetify.breakpoint.mobile ? '120' : '165'" :height="$vuetify.breakpoint.mobile ? '31' : '41'" contain />
                                    </v-col>
                                    <v-spacer />
                                    <v-col v-show="$vuetify.breakpoint.mobile" cols="auto">
                                        <a @click="open('https://instagram.com/daehan_bookstore?utm_medium=copy_link')" class="d-block pa-4px">
                                            <v-img src="/images/icon-instagram.png" width="24" height="24" />
                                        </a>
                                    </v-col>
                                    <v-col v-show="$vuetify.breakpoint.mobile" cols="auto">
                                        <a @click="open('https://blog.naver.com/dhbooks_')" class="d-block pa-4px">
                                            <v-img src="/images/icon-nblog.png" width="24" height="24" />
                                        </a>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <div class="pt-20px pt-lg-0px pl-lg-20px">
                                    <!-- S: 회사 정보 — 좌측 발행대행(페이솔루스) · 우측 판매자(대한문고) -->
                                    <v-row no-gutters>
                                        <v-col cols="12" lg="6">
                                            <div class="pr-lg-20px">
                                                <div class="font-size-14 line-height-14 font-weight-bold grey--text text--darken-4">선불전자지급수단 발행 · 관리(상품권 운영사)</div>
                                                <div class="mx-n4px mt-8px">
                                                    <v-row no-gutters class="font-size-14 line-height-14 grey--text text--darken-2">
                                                        <v-col cols="auto">
                                                            <div class="px-4px pa-2px"><b class="grey--text text--darken-4 mr-6px">회사명</b><span>주식회사 페이솔루스</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">사업자등록번호</b><span>605-81-90742</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">선불전자지급수단 발행 및 관리업 등록번호</b><span>02-002-00020</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">통신판매 신고번호</b><span>2005-서울송파-3100</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">E-mail</b><span>Helpdesk@paysolus.co.kr</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">고객센터</b><span>1566-1291</span></div>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" lg="6">
                                            <div class="mt-20px mt-lg-0px">
                                                <div class="font-size-14 line-height-14 font-weight-bold grey--text text--darken-4">상품권 브랜드사</div>
                                                <div class="mx-n4px mt-8px">
                                                    <v-row no-gutters class="font-size-14 line-height-14 grey--text text--darken-2">
                                                        <v-col cols="auto">
                                                            <div class="px-4px pa-2px"><b class="grey--text text--darken-4 mr-6px">회사명</b><span>주식회사 대한문고</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">주소</b><span>서울특별시 강서구 마곡중앙로 171 마곡나루역 프라이빗타워2차 10층</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">대표번호</b><span>1800-9510</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">FAX</b><span>02-6442-9520</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">사업자등록번호</b><span>846-81-00822</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">통신판매업신고번호</b><span>제_2020-서울강서-1979 호</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">대표자</b><span>우상덕</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">개인정보관리책임자</b><span>서순명 이사</span></div>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <div class="pa-2px"><b class="grey--text text--darken-4 mr-6px">E-mail</b><span>help@daehanbooks.co.kr</span></div>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <!-- E: 회사 정보 -->

                                    <div class="mt-16px">
                                        <v-row align="center">
                                            <!-- <v-col cols="auto"><v-img src="/images/nicepay-mark.png" contain/></v-col> -->
                                            <!-- <v-col cols="auto"><v-img src="/images/kakaopay-mark.png" contain/></v-col> -->
                                            <!-- <v-col cols="auto"><v-img src="/images/applepay-mark.png" contain/></v-col> -->
                                            <!-- <v-col cols="auto"><v-img src="/images/samsungpay-mark.png" contain/></v-col> -->
                                            <!-- <v-col cols="auto"><v-img src="/images/naver-mark.png" contain/></v-col> -->
                                            <!-- <v-col cols="auto"><v-img src="/images/kg-mark.png" contain /></v-col> -->
                                            <v-col cols="auto"><v-img src="/images/sgi-mark.png" contain /></v-col>
                                            <v-col cols="auto"><v-img src="/images/biz-mark.svg" contain width="72" /></v-col>
                                        </v-row>
                                    </div>

                                    <div class="font-size-14 line-height-14 grey--text text--darken-2 mt-16px">
                                        <div>상표등록 출원번호 4020180121475, 4020210131548 무단 도용 시 법적 불이익을 받습니다.</div>
                                        <div class="mt-4px">ⓒ 2022. BOOK Inc. all right reserved.</div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-footer>
            </v-lazy>
        </v-responsive>
        <!-- E: Footer -->

        <!-- S: Floating Action Button -->
        <slot name="fab" v-bind:scrollTo="scrollTo" v-bind:showScroll="showScroll">
            <v-btn v-show="showScroll" fab fixed bottom right large tile color="primary" class="mt-n10" @click="scrollTo(0, 0)">
                <div class="pa-12px">
                    <v-icon size="20" class="my-n4px">mdi-chevron-up</v-icon>
                    <div class="font-size-14 font-weight-medium mb-6px">TOP</div>
                </div>
            </v-btn>
        </slot>
        <!-- E: Floating Action Button -->
    </v-app>
</template>
<script>
import api from "@/api";
import { mdiChevronUp, mdiAccountPlusOutline, mdiTextBoxOutline, mdiLockOutline, mdiCartOutline, mdiAccountOutline, mdiAlarm } from "@mdi/js";
import GlobalNavigationBar from "@/components/client/gnb/global-navigation-bar.vue";
import ClientFloatingActions from "@/components/client/client-floating-actions.vue";
import ClientGiftNoti from '@/components/client/client-gift-noti.vue';

export default {
    components: {
        GlobalNavigationBar,
        ClientFloatingActions,
        ClientGiftNoti,
    },
    data() {
        return {
            mdiAlarm,
            mdiChevronUp,
            mdiTextBoxOutline,
            mdiAccountPlusOutline,
            mdiAccountOutline,
            mdiLockOutline,
            mdiCartOutline,

            maxWidth: 1200,

            drawer: false,

            isActive: false,

            showScroll: false,
            showFooter: false,

            bestsellerCategory: null,
            childrenCategory: null,
            discountCategory: null,
            shoppingCategory: null,

            searchValue: -1 < this.$route.path.indexOf("/search") ? this.$route.query.searchValue : null,
        };
    },
    async mounted() {
        // this.$nextTick(_ => this.isActive = true )
        this.onTimer();
        await this.init();
    },
    methods: {
        async init() {
            let { categories } = await api.v1.shop.categories.gets({ params: { depth: 1 } });
            this.bestsellerCategory = categories.find((category) => category.code == "book")?.children?.find?.((category) => category.code == "bestseller");
            this.childrenCategory = categories.find((category) => category.code == "book")?.children?.find?.((category) => category.code == "children");
            this.discountCategory = categories.find((category) => category.code == "book")?.children?.find?.((category) => category.code == "discount");
            this.shoppingCategory = categories.find((category) => category.code == "shopping");
        },
        login() {
            this.$router.push(`/login`);
        },
        logout() {
            this.$store.dispatch("logout");
            this.$$router.push("/");
        },
        search() {
            if (!this.searchValue) {
                alert("검색어 키워드를 입력해주세요");
                return;
            }

            this.$router.push(`/search?searchValue=${this.searchValue}`);
        },

        open(url) {
            window.open(url);
        },

        onFooter(entries, observer) {
            this.showFooter = entries[0].isIntersecting;
        },

        onScroll(entries, observer) {
            this.showScroll = !entries[0].isIntersecting;
        },

        scrollTo(x, y) {
            return window.scrollTo(x, y);
        },

        onTimer() {
            if (this.$cookies.get("timerInstance")) clearTimeout(this.$cookies.get("timerInstance"));
            this.$forceUpdate();
            this.$cookies.set(
                "timerInstance",
                setTimeout(() => this.onTimer(), 1000)
            );
        },

        remain() {
            let now = Date.now();
            let exp = (+this.payload?.exp || 0) * 1000 < now ? now : this.payload?.exp * 1000;

            let remain = exp - now;
            let minute = String(Math.floor(remain / 60000)).padStart(2, 0);
            let second = String(Math.floor((remain - minute * 60000) / 1000)).padStart(2, 0);
            return `${minute}:${second}`;
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        logon() {
            return !!this.accessToken;
        },
        logoff() {
            return !this.accessToken;
        },
        backgroundColor() {
            return this.$route.path == "/" ? "white" : "var(--v-content-base) !important";
        },
        scope() {
            return this.$store.state.scope;
        },
        payload() {
            return this.$store.state.payload;
        },
    },
    watch: {
        accessToken() {
            if (!this.accessToken) {
                this.$router.go(0);
            }
        },
        scope() {
            if (this.scope.includes("cert")) {
                this.timer();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.v-cloak {
    display: none;
}
.header {
    z-index: 2;
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #ffffff;
        box-shadow: 0px 5px 13px 0px rgba(74, 74, 74, 0.15) !important;
        -webkit-transition: all ease 0.15s;
        transition: all ease 0.15s;
    }
}
.app .header-timer {
    position: absolute;
    width: auto;
    height: auto;
    right: 10px;
    top: 50%;
    bottom: 0;
    margin: auto;
    margin-top: -10px;
}

.header,
.mobile-navigation-drawer {
    .new {
        position: relative;
        &::after {
            content: "";
            position: absolute;
            background: url(/images/icon/icon-new.png) no-repeat center / cover;
            pointer-events: none;
        }
    }
}
.header .new {
    &::after {
        top: -11px;
        left: 10px;
        width: 43px;
        height: 37px;
    }
}
.mobile-navigation-drawer .new {
    &::after {
        width: 26px;
        height: 21px;
        left: 2px;
        top: 0;
        min-height: initial;
    }
}
.prepend-menu {
    padding: 24px 36px;
}
.prepend-menu__li {
    margin-top: 16px;
}
.prepend-menu__li:first-child {
    margin-top: 0;
}
.prepend-menu__tit {
    font-size: 18px;
    font-weight: 700;
    color: #222;
}
.prepend-menu .sub-menu {
    padding-left: 10px;
}
.prepend-menu .sub-menu li {
    margin-top: 8px;
}
.prepend-menu .sub-menu a {
    position: relative;
    font-size: 16px;
    font-weight: 400;
    color: #222;
}
header .v-sheet.v-list:not(.v-sheet--outlined) {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
}

.v-menu__content {
    box-shadow: none;
    padding: 0 15px 15px 15px;
    transform: translate(-15px);
}

.prepend-menu .sub-menu a::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: -2px;
    width: calc(100% + 4px);
    height: 10px;
    background: #2676f3;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: left;
    transform-origin: left;
    -webkit-transition: all ease 0.15s;
    transition: all ease 0.15s;
    opacity: 0.25;
}
.prepend-menu .sub-menu a:hover::before {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
}

.prepend-menu-sub {
    width: 200px;
    padding: 0;
}

.prepend-menu-sub__li a {
    font-size: 16px;
    color: #555 !important;
    height: 55px;
    display: flex;
    align-items: center;
    padding: 0 30px;
    width: 200px;
}
.prepend-menu-sub__li:hover > a {
    color: #222 !important;
}

.logo-wrap,
.new--menu__li,
.new--menu-mo,
.new--menu__li-mo {
    position: relative;
}

/**new 아이콘 */

/* .logo-wrap::after {
    content: "";
    display: block;
    width: 655px;
    height: 27px;
    position: absolute;
    bottom: 5px;
    left: 275px;
    background-image: url(/images/icon/new-top.png);
    background-position: center;
    background-repeat: no-repeat;
    animation: new 0.8s infinite linear;
}

@keyframes new {
    0% {
        opacity: 0;
    }
    1% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    51% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
} */

.new--menu__li::after {
    content: "";
    display: block;
    width: 17px;
    height: 17px;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    background-image: url(/images/icon/new.png);
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
}

.new--menu-mo::after {
    content: "";
    display: block;
    width: 70px;
    height: 19px;
    left: 42px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    background-image: url(/images/icon/new-top-mo.png);
    background-position: center;
    background-repeat: no-repeat;
    animation: new 0.8s infinite linear;
}

.new--menu__li-mo::after {
    content: "";
    display: block;
    width: 17px;
    height: 17px;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    background-image: url(/images/icon/new.png);
    background-position: center;
    background-repeat: no-repeat;
}

/* 20221104 베스트셀러 3뎁스 추가 */
.prepend-menu-sub__li__dept3-wrap {
    position: relative;
}

.prepend-menu-sub__li__dept3-wrap:hover > a {
    background-image: url(/images/icon/icon-right-arrow.svg);
    background-position: right 30px center;
    background-repeat: no-repeat;
    background-size: 8px auto;
}

.prepend-menu-sub__li__dept3 {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(100%);
    opacity: 0;
    visibility: hidden;
    transition: 0.15s ease-out;
}

.prepend-menu-sub__li__dept3-wrap:hover .prepend-menu-sub__li__dept3 {
    opacity: 1;
    visibility: visible;
}

.prepend-menu-sub__li__dept3 li a {
    height: 45px;
    padding: 0 20px;
    min-width: 160px;
    background-color: #f8f8f8;
}

.prepend-menu-sub__li__dept3 li a:hover {
    background-color: #fff;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}

.mobile-navigation-drawer {
    z-index: 10001;
}
</style>
